import styled from "styled-components";
import { LoadingProducts } from "./LoadingProducts";

export const LoadingBrandGrid = () => {
  return (
    <Wrapper>
      <main>
        <div className="container-loader">
          <div className="grid-body-loader">
            <div className="grid-title-loader">
              <div>
                <div className="brand-title-loader">
                  <div className="brand-name-loader">
                    <svg
                      viewBox="0 0 556 30"
                      version="1.1"
                      preserveAspectRatio="none"
                      speed="2"
                      className="loader-placeholder--storeName"
                    >
                      <rect
                        clipPath="url(#zpo4yqmgm9)"
                        x="0"
                        y="0"
                        width="556"
                        height="30"
                        style={{ fill: `url(#fogtu6dz47o)` }}
                      ></rect>
                      <defs>
                        <clipPath id="zpo4yqmgm9">
                          <rect
                            x="0"
                            y="0"
                            rx="20"
                            ry="20"
                            width="556"
                            height="30"
                            fill="#F5F5F5"
                          ></rect>
                        </clipPath>
                        <linearGradient id="fogtu6dz47o">
                          <stop offset="0%" stopColor="#f9f9f9" stopOpacity="1">
                            <animate
                              attributeName="offset"
                              values="-2; 1"
                              dur="6s"
                              repeatCount="indefinite"
                            ></animate>
                          </stop>
                          <stop
                            offset="50%"
                            stopColor="#ecebeb"
                            stopOpacity="1"
                          >
                            <animate
                              attributeName="offset"
                              values="-1.5; 1.5"
                              dur="6s"
                              repeatCount="indefinite"
                            ></animate>
                          </stop>
                          <stop
                            offset="100%"
                            stopColor="#f9f9f9"
                            stopOpacity="1"
                          >
                            <animate
                              attributeName="offset"
                              values="-1; 2"
                              dur="6s"
                              repeatCount="indefinite"
                            ></animate>
                          </stop>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div className="icons">
                    <div className="del-icon-container">
                      <svg
                        viewBox="0 0 20 20"
                        version="1.1"
                        preserveAspectRatio="xMidYMid meet"
                        speed="2"
                        className="loader-placeholder loader-placeholder--icon"
                      >
                        <rect
                          clipPath="url(#04newtx18l89)"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                          style={{ fill: "url(#45hreojiq42)" }}
                        ></rect>
                        <defs>
                          <clipPath id="04newtx18l89">
                            <circle
                              cx="10"
                              cy="10"
                              r="10"
                              fill="#F5F5F5"
                            ></circle>
                          </clipPath>
                          <linearGradient id="45hreojiq42">
                            <stop
                              offset="0%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-2; 1"
                                dur="6s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="50%"
                              stopColor="#ecebeb"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1.5; 1.5"
                                dur="6s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="100%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1; 2"
                                dur="6s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                          </linearGradient>
                        </defs>
                      </svg>
                      <svg
                        viewBox="0 0 65 20"
                        version="1.1"
                        preserveAspectRatio="xMidYMid meet"
                        speed="2"
                        className="loader-placeholder loader-placeholder--tag"
                      >
                        <rect
                          clipPath="url(#z3b46yc25c)"
                          x="0"
                          y="0"
                          width="65"
                          height="20"
                          style={{ fill: "url(#us5toi6ugc)" }}
                        ></rect>
                        <defs>
                          <clipPath id="z3b46yc25c">
                            <rect
                              y="0.00195312"
                              width="65"
                              height="20"
                              rx="10"
                              fill="#F5F5F5"
                            ></rect>
                          </clipPath>
                          <linearGradient id="us5toi6ugc">
                            <stop
                              offset="0%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-2; 1"
                                dur="2s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="50%"
                              stopColor="#ecebeb"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1.5; 1.5"
                                dur="2s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="100%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1; 2"
                                dur="2s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div className="del-icon-container">
                      <svg
                        viewBox="0 0 20 20"
                        version="1.1"
                        preserveAspectRatio="xMidYMid meet"
                        speed="2"
                        className="loader-placeholder loader-placeholder--icon"
                      >
                        <rect
                          clipPath="url(#04newtx18l89)"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                          style={{ fill: "url(#45hreojiq42)" }}
                        ></rect>
                        <defs>
                          <clipPath id="04newtx18l89">
                            <circle
                              cx="10"
                              cy="10"
                              r="10"
                              fill="#F5F5F5"
                            ></circle>
                          </clipPath>
                          <linearGradient id="45hreojiq42">
                            <stop
                              offset="0%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-2; 1"
                                dur="6s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="50%"
                              stopColor="#ecebeb"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1.5; 1.5"
                                dur="6s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="100%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1; 2"
                                dur="6s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                          </linearGradient>
                        </defs>
                      </svg>
                      <svg
                        viewBox="0 0 65 20"
                        version="1.1"
                        preserveAspectRatio="xMidYMid meet"
                        speed="2"
                        className="loader-placeholder loader-placeholder--tag"
                      >
                        <rect
                          clipPath="url(#z3b46yc25c)"
                          x="0"
                          y="0"
                          width="65"
                          height="20"
                          style={{ fill: "url(#us5toi6ugc)" }}
                        ></rect>
                        <defs>
                          <clipPath id="z3b46yc25c">
                            <rect
                              y="0.00195312"
                              width="65"
                              height="20"
                              rx="10"
                              fill="#F5F5F5"
                            ></rect>
                          </clipPath>
                          <linearGradient id="us5toi6ugc">
                            <stop
                              offset="0%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-2; 1"
                                dur="2s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="50%"
                              stopColor="#ecebeb"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1.5; 1.5"
                                dur="2s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="100%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1; 2"
                                dur="2s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div className="del-icon-container">
                      <svg
                        viewBox="0 0 20 20"
                        version="1.1"
                        preserveAspectRatio="xMidYMid meet"
                        speed="2"
                        className="loader-placeholder loader-placeholder--icon"
                      >
                        <rect
                          clipPath="url(#04newtx18l89)"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                          style={{ fill: "url(#45hreojiq42)" }}
                        ></rect>
                        <defs>
                          <clipPath id="04newtx18l89">
                            <circle
                              cx="10"
                              cy="10"
                              r="10"
                              fill="#F5F5F5"
                            ></circle>
                          </clipPath>
                          <linearGradient id="45hreojiq42">
                            <stop
                              offset="0%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-2; 1"
                                dur="6s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="50%"
                              stopColor="#ecebeb"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1.5; 1.5"
                                dur="6s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="100%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1; 2"
                                dur="6s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                          </linearGradient>
                        </defs>
                      </svg>
                      <svg
                        viewBox="0 0 65 20"
                        version="1.1"
                        preserveAspectRatio="xMidYMid meet"
                        speed="2"
                        className="loader-placeholder loader-placeholder--tag"
                      >
                        <rect
                          clipPath="url(#z3b46yc25c)"
                          x="0"
                          y="0"
                          width="65"
                          height="20"
                          style={{ fill: "url(#us5toi6ugc)" }}
                        ></rect>
                        <defs>
                          <clipPath id="z3b46yc25c">
                            <rect
                              y="0.00195312"
                              width="65"
                              height="20"
                              rx="10"
                              fill="#F5F5F5"
                            ></rect>
                          </clipPath>
                          <linearGradient id="us5toi6ugc">
                            <stop
                              offset="0%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-2; 1"
                                dur="2s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="50%"
                              stopColor="#ecebeb"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1.5; 1.5"
                                dur="2s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                            <stop
                              offset="100%"
                              stopColor="#f9f9f9"
                              stopOpacity="1"
                            >
                              <animate
                                attributeName="offset"
                                values="-1; 2"
                                dur="2s"
                                repeatCount="indefinite"
                              ></animate>
                            </stop>
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div className="brand-message-loader">
                    <svg
                      viewBox="0 0 556 30"
                      version="1.1"
                      preserveAspectRatio="none"
                      speed="2"
                      className="loader-placeholder--storeName"
                    >
                      <rect
                        clipPath="url(#zpo4yqmgm9)"
                        x="0"
                        y="0"
                        width="556"
                        height="30"
                        style={{ fill: `url(#fogtu6dz47o)` }}
                      ></rect>
                      <defs>
                        <clipPath id="zpo4yqmgm9">
                          <rect
                            x="0"
                            y="0"
                            rx="20"
                            ry="20"
                            width="556"
                            height="30"
                            fill="#F5F5F5"
                          ></rect>
                        </clipPath>
                        <linearGradient id="fogtu6dz47o">
                          <stop offset="0%" stopColor="#f9f9f9" stopOpacity="1">
                            <animate
                              attributeName="offset"
                              values="-2; 1"
                              dur="6s"
                              repeatCount="indefinite"
                            ></animate>
                          </stop>
                          <stop
                            offset="50%"
                            stopColor="#ecebeb"
                            stopOpacity="1"
                          >
                            <animate
                              attributeName="offset"
                              values="-1.5; 1.5"
                              dur="6s"
                              repeatCount="indefinite"
                            ></animate>
                          </stop>
                          <stop
                            offset="100%"
                            stopColor="#f9f9f9"
                            stopOpacity="1"
                          >
                            <animate
                              attributeName="offset"
                              values="-1; 2"
                              dur="6s"
                              repeatCount="indefinite"
                            ></animate>
                          </stop>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid-chart-loader">
              <h2 className="chart-heading">Your plova...</h2>
              <div className="chart-loader"></div>
            </div>
            <div className="grid-sections-loader">
              <div className="sections-loader">
                <svg
                  viewBox="0 0 65 20"
                  version="1.1"
                  preserveAspectRatio="xMidYMid meet"
                  speed="2"
                  className="loader-placeholder--tag"
                >
                  <rect
                    clipPath="url(#z3b46yc25c)"
                    x="0"
                    y="0"
                    width="65"
                    height="20"
                    style={{ fill: "url(#us5toi6ugc)" }}
                  ></rect>
                  <defs>
                    <clipPath id="z3b46yc25c">
                      <rect
                        y="0.00195312"
                        width="65"
                        height="20"
                        rx="10"
                        fill="#F5F5F5"
                      ></rect>
                    </clipPath>
                    <linearGradient id="us5toi6ugc">
                      <stop offset="0%" stopColor="#f9f9f9" stopOpacity="1">
                        <animate
                          attributeName="offset"
                          values="-2; 1"
                          dur="2s"
                          repeatCount="indefinite"
                        ></animate>
                      </stop>
                      <stop offset="50%" stopColor="#ecebeb" stopOpacity="1">
                        <animate
                          attributeName="offset"
                          values="-1.5; 1.5"
                          dur="2s"
                          repeatCount="indefinite"
                        ></animate>
                      </stop>
                      <stop offset="100%" stopColor="#f9f9f9" stopOpacity="1">
                        <animate
                          attributeName="offset"
                          values="-1; 2"
                          dur="2s"
                          repeatCount="indefinite"
                        ></animate>
                      </stop>
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
            <div className="grid-products-loader">
              <LoadingProducts />
            </div>
          </div>
        </div>
      </main>
      <footer className="transition"></footer>
    </Wrapper>
  );
};

const Wrapper = styled.main`
  margin-top: -10rem;
  overflow-x: hidden;
  .grid-body-loader {
    display: grid;
    grid-template-columns: 0.5fr 4.25fr 1.5fr;
    grid-template-rows: 20rem 1fr;
    column-gap: 1rem;
    row-gap: 1.6rem;
  }

  .grid-title-loader {
    padding: 0 2rem;
    display: flex;
    max-width: 130rem;
    max-height: 18rem;
    grid-column: 1/3;
    grid-row: 1/2;
    box-shadow: 0 2px 20px rgb(0 0 0 / 10%);
    background: #fff;
    padding: 2rem 4rem;
    border-radius: 1rem;
  }

  .brand-title-loader {
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
  }

  .brand-name-loader {
    max-width: 60rem;
  }

  .brand-message-loader {
    max-width: 40rem;
  }

  .icons {
    display: flex;
    justify-content: row;
    gap: 5rem;
  }

  .del-icon-container {
    height: 2rem;
    display: flex;
    flex-direction: row;
    gap: 1rem;
  }

  .loader-placeholder-loader-placeholder--storeName {
    min-height: 5em;
  }

  .loader-placeholder--icon {
    min-height: 2rem;
  }

  .grid-chart-loader {
    background-color: #fff;
    box-shadow: 0 2px 20px rgb(0 0 0 / 10%);
    height: 48rem;
    width: 32rem;
    border-radius: 1rem;
  }

  .chart-heading {
    text-align: center;
    padding-top: 5rem;
    font-size: 2.8rem;
    color: grey;
  }

  .grid-sections-loader {
    background-color: #fff;
    width: 17.5rem;
    min-height: 50rem;
    padding-bottom: 5rem;
  }

  .sections-loader {
    padding: 1rem;

    .loader-placeholder--tag {
      height: 4rem;
    }
  }

  .grid-products-loader {
    background-color: #fff;
    padding: 1rem 0rem 1rem 0rem;
    min-height: auto;
    max-width: 120rem;
  }

  .transition {
    display: block;
    width: 110%;
    height: 12.5rem;
    background-color: #1d1d1d;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    margin: 2rem -10rem -5rem -10rem;
  }

  @media (max-width: 85em) {
    .grid-chart-loader {
      display: none;
    }

    .grid-body-loader {
      grid-template-columns: 0.5fr 4.25fr;
      column-gap: 0rem;
    }

    .transition-container {
      overflow: hidden;
      width: 100vw;
    }

    .transition {
      display: block;
      width: 120%;
      height: 4.5rem;
      background-color: #1d1d1d;
      border-top-left-radius: 50%;
      border-top-right-radius: 50%;
      margin: 0rem -5rem 0rem -5rem;
    }

    .grid-title-loader {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 130rem;
      max-height: 18rem;
      grid-column: 1/3;
      grid-row: 1/2;
      box-shadow: 0 2px 20px rgb(0 0 0 / 10%);
      background: #fff;
      padding: 2rem 4rem;
      border-radius: 1rem;
    }
  }

  @media (max-width: 40.625em) {
    .grid-body-loader {
      grid-template-columns: 1fr;
      column-gap: 0rem;
    }

    .grid-sections-loader {
      display: none;
    }
  }

  @media (max-width: 31.5em) {
    .grid-title-loader {
      // display: flex;
      // align-items: center;
      // justify-content: center;
      max-width: auto;
      max-height: 18rem;

      // padding: 1rem 1rem;
    }

    .brand-title-loader {
      display: flex;
      flex-direction: column;
      gap: 1.8rem;
    }

    .brand-name-loader {
      max-width: 20rem;
    }

    .brand-message-loader {
      max-width: 10rem;
    }

    .icons {
      display: flex;
      justify-content: row;
      gap: 1rem;
    }

    .del-icon-container {
      // max-width: 2rem;
      height: 1.6rem;
      display: flex;
      flex-direction: row;
      gap: 1rem;
    }

    .loader-placeholder-loader-placeholder--storeName {
      min-height: 4rem;
    }

    .loader-placeholder--icon {
      min-height: 1.6rem;
    }
  }
`;
